<template>
    <tbody>
        <tr :class="{'ai-record-detail':expanded, 'ai-record-summary':!expanded}">
            <td class="record-item" style="width:30%">{{ row.displayName }}</td>
            <td class="record-item" style="width:28%">
                <img v-if="row.iconUrl" style="width:20px;vertical-align:middle" :src="row.iconUrl" alt=""/>
                <img v-else style="width:20px;vertical-align:middle" :src="getDefaultIconUrl" alt=""/>
                <span class="record-item" style="padding-left:10px;width:45%">{{ getLocaledText(row.templateName) }}</span>
            </td>
            <td class="record-item" style="width:12%">
                <button class="transparent" type="button" v-on:click="handleOnAssign"><span class="normal-command-text" v-t="'message.action_assign'"></span></button>
            </td>
            <td class="record-item" style="width:10%">
                <button class="transparent" type="button" v-on:click="showDialog.edit = true"><img src="@/assets/edit.svg" alt=""/></button>
            </td>
            <td class="record-item" style="width:10%">
                <button class="transparent" type="button" v-on:click="showDialog.delete = true"><img src="@/assets/icon_delete_user.svg" alt=""/></button>
            </td>
            <td v-if="!expanded" class="record-item" style="width:10%">
                <button class="transparent" type="button" v-on:click="expanded = true; getAssignedGroup()"><i class="el-icon-arrow-down"></i></button>
            </td>
            <td v-else class="record-item" style="width:10%">
                <button class="transparent" type="button" v-on:click="expanded = false"><i class="el-icon-arrow-up"></i></button>
            </td>

            <AiAppSettingDefinitionEdit
                v-if="showDialog.edit"
                :data="row"
                :type = "type"
                @save="modifyAiAppSetting"
                @cancel="showDialog.edit=false"
            />
            <DeleteObject
                v-if="showDialog.delete"
                :confirmInfo="{
                    objectTitle: $t('message.item_ai_assistant'),
                    objectName: row.displayName
                }"
                @delete="deleteAiAppSetting"
                @cancel="showDialog.delete=false"
            />
            <AiAppSettingDefinitionAssign
                v-if="showDialog.assign"
                :tenantId="$root.store.tenantId"
                :type="type"
                :processorDefinition="row"
                :assignedGroup="assignedGroup"
                @save="assignRequest"
                @cancel="showDialog.assign = false"
            />
        </tr>

        <template v-if="expanded">
        <tr>
            <td colspan="7" class="detailed-header">
                <div class="title-box-left" v-t="'message.item_assigned_groups'">
                </div>
            </td>
        </tr>
        <tr>
            <td colspan="7" class="detailed-left" style="padding-left:40px">
                {{ assignedGroupToShow }}
            </td>
        </tr>
        <tr>
            <td colspan="7">
                <div v-for="section in row.sections">
                    <template v-if="existsContents(section)">
                        <div class="detailed-header">
                            <div class="title-box-left">
                                {{ getLocaledText(section.name) }}
                            </div>
                        </div>
                        <div v-if="isVisible(section) && hasSelection(section)">
                            <table width="100%" cellpadding=0 cellspacing=0>
                                <tr class="detailed-tr">
                                    <td class="detailed-left">{{getLocaledText(section.title)}}</td>
                                    <td>{{ getNameOfSelectedValue(section) }}</td>
                                </tr>
                            </table>
                        </div>
                        <AiAppSettingDefinitionRowDetail :processor="section"/>
                    </template>
                </div>
                <div v-for="section in row.sectionsShowOnly">
                    <div class="detailed-header">
                        <div class="title-box-left">
                            {{ getLocaledText(section.name) }}
                        </div>
                    </div>
                    <AiAppSettingDefinitionRowDetail :processor="section"/>
                </div>
            </td>
        </tr>
        </template>
    </tbody>
</template>

<script>

import server from "@/components/ServerApi";
import constants from "@/components/constants";
import commonUtil from "@/components/commonutil";
import AiAppSettingUtility from "@/components/pc/setting/ai-app/AiAppSettingUtility";
import AiAppSettingDefinitionEdit from "@/components/pc/setting/ai-app/AiAppSettingDefinitionEdit";
import DeleteObject from "@/components/DeleteObject";
import AiAppSettingDefinitionAssign from "@/components/pc/setting/ai-app/AiAppSettingDefinitionAssign";
import AiAppSettingDefinitionRowDetail from "@/components/pc/setting/ai-app/AiAppSettingDefinitionRowDetail";

export default {
    mixins:[AiAppSettingUtility],

    components:{ AiAppSettingDefinitionRowDetail, AiAppSettingDefinitionEdit, DeleteObject, AiAppSettingDefinitionAssign },

    props: {
        type: {
          type: String,
          required: true
        },
        definition: {
            type: Object,
            required: true
        }
    },

    data() {
          return {
              assignedGroup: null,
              expanded: false,
              showDialog: {
                  edit: false,
                  delete: false,
                  assign: false
              }
          }
    },

    computed: {
        row() {
            if (this.type === AiAppSettingUtility.TYPE_PROCESSOR) {
                const helpHtml = 'helpHtml' in this.definition.definition ? this.definition.definition['helpHtml'] : null
                const iconUrl = 'iconUrl' in this.definition.definition ? this.definition.definition['iconUrl'] : null

                return {
                    id: this.definition.id,
                    serviceId: this.definition.serviceId,
                    processorTemplateId: this.definition.processorTemplateId,
                    templateName: this.definition.definition.name,
                    displayName: this.definition.displayName,
                    helpHtml: helpHtml,
                    iconUrl: iconUrl,
                    needStt: this.definition.definition.needStt,
                    sections: this.definition.definition['processors']
                }
            } else if (this.type === AiAppSettingUtility.TYPE_SERVICE_INFORMATION) {
                switch (this.definition.serviceName) {
                    case AiAppSettingUtility.SERVICE_NAME_GIGARAKU_CAMERA:
                        const buddycomSectionSection = {
                            name: {
                                en: 'Collaboration　setting',
                                ja: '連携設定(Buddycom)'
                            },
                            parameters: [
                                {
                                    selectUser: true,
                                    jsonKey: "senderName",
                                    title: {
                                        en: 'Notification user',
                                        ja: '通知用ユーザ-'
                                    },
                                    type: "text",
                                    disabled: true,
                                    value: this.definition.value['senderName'],
                                    validationRule: "reqHalfWideLetter"
                                }
                            ]
                        }

                        const gigarakuCameraUserSettingSection = {
                            name: {
                                en: 'Collaboration　setting',
                                ja: '連携設定(クラウドカメラユーザー)'
                            },
                            parameters: [
                                {
                                    jsonKey: "registerUserUrl",
                                    title: {
                                        en: 'Site to register user',
                                        ja: 'ユーザー登録サイト'
                                    },
                                    type: "text",
                                    link: true,
                                    value: 'https://cloud-camera.safie.link/app/auth/register'
                                },
                                {
                                    jsonKey: "emailAddress",
                                    title: {
                                        en: 'Email address　for user',
                                        ja: 'ユーザー用メールアドレス'
                                    },
                                    type: "text",
                                    value: this.definition.id + '-' + this.$root.store.tenantId + '@' + this.definition.value['serviceDomain'],
                                }
                            ]
                        }

                        const gigarakuCameraAuthenticationSettingSection = {
                            name: {
                                en: 'Collaboration　setting',
                                ja: '認証メールアドレス設定'
                            },
                            parameters: [
                                {
                                    jsonKey: "authenticationEmail",
                                    title: {
                                        en: 'Email address　for authentication',
                                        ja: '認証用メールアドレス'
                                    },
                                    type: "text",
                                    value: this.definition.value['authenticationEmail'],
                                    validationRule: "emailAddress"
                                }
                            ]
                        }

                        if (this.definition.cachedValue != null) {
                            gigarakuCameraSettingSection.parameters.push(
                                {
                                    jsonKey: "passwordReset",
                                    title: {
                                        en: 'Site for password reset',
                                        ja: 'パスワードリセットサイト'
                                    },
                                    type: "text",
                                    link: true,
                                    value: "https://safie.link/app/auth/reset?token=" + this.definition.cachedValue
                                }
                            )
                        }

                        return {
                            serviceName: this.definition.serviceName,
                            id: this.definition.id,
                            templateName : {
                                en : 'Cloud Camera',
                                ja : 'クラウドカメラ'
                            },
                            displayName: this.definition.value['displayName'],
                            helpHtml: null,
                            iconUrl: this.getDefaultIconUrl(),
                            sections: [buddycomSectionSection, gigarakuCameraAuthenticationSettingSection],
                            sectionsShowOnly: [gigarakuCameraUserSettingSection]
                        }
                }

            }
        },

        assignedGroupToShow() {
            if (this.assignedGroup == null || this.assignedGroup.length === 0) {
                return commonUtil.getMessageText(this.$i18n,"info_not_assigned_to_group");
            } else {
                return this.assignedGroup.map(group => group.displayName).join()
            }
        }
    },

    methods: {
        async handleOnAssign() {
            await this.getAssignedGroup();
            this.showDialog.assign = true;
        },

        async getAssignedGroup() {
            if (this.assignedGroup == null) {
                if (this.type === AiAppSettingUtility.TYPE_PROCESSOR) {
                    await this.fetchAiAssignedGroupInfo()
                } else if (this.type === AiAppSettingUtility.TYPE_SERVICE_INFORMATION) {
                    switch (this.definition.serviceName) {
                        case AiAppSettingUtility.SERVICE_NAME_GIGARAKU_CAMERA:
                            if (this.definition.value['groupName'] != null) {
                                await this.fetchGroupInformation(this.definition.value['groupName'])
                            } else {
                                this.assignedGroup = []
                            }
                    }
                }
            }
        },

        async fetchAiAssignedGroupInfo() {
            this.assignedGroup = []
            try {
                const res = await server.post('/gettalkgroupsbyprocessordefinition', { processorDefinitionId: this.row.id })

                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        break;
                    default:
                        commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","getAiAssignedGroupInfo").replace("{code}",res.data.status));
                        return;
                }

                for (let talkgroupInfo of res.data.talkgroups) {
                    this.assignedGroup.push(
                        {
                            id: talkgroupInfo.talkgroupId,
                            name: talkgroupInfo.talkgroupName,
                            type: constants.OBJECT_TALKGROUP,
                            displayName: talkgroupInfo.displayName,
                            processorDefinitionIds: talkgroupInfo.processorDefinitionIds,
                        }
                    );
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "fetchAiAssignedGroupInfo", error);
            }
        },

        async fetchGroupInformation(groupNameList) {
            this.assignedGroup = []
            // TODO: getInfo requests should be post in once.
            for (let groupName of groupNameList) {
                const res = await server.post('/getinfo', { tenantId: this.$root.store.tenantId, name: groupName, type: constants.OBJECT_TALKGROUP})
                if (res.data.status >= 0) {
                    this.assignedGroup.push(
                        {
                            id: res.data.id,
                            name: res.data.name,
                            type: constants.OBJECT_TALKGROUP,
                            displayName: res.data.displayName
                        }
                    )
                } else {
                    commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","fetchGroupInformation").replace("{code}",res.data.status));
                }
            }

        },

        modifyAiAppSetting(input) {
            const self = this

            if (this.type === AiAppSettingUtility.TYPE_PROCESSOR) {
                const param = {
                    id: this.row.id,
                    processorTemplateId: this.row.processorTemplateId,
                    displayName: input.displayName,
                    definition: {
                        processors: input.sections
                    }
                }
                this.$emit('modify', '/modifyprocessordefinition', param)
            } else if (this.type === AiAppSettingUtility.TYPE_SERVICE_INFORMATION) {
                const value = {}

                if (this.row.displayName !== input.displayName) {
                    value['displayName'] = input.displayName
                }

                for (let i = 0; i < this.row.sections.length; i++) {
                    let rowSection = this.row.sections[i]
                    let inputSection = input.sections[i]
                    for (let j = 0; j < rowSection.parameters.length; j++) {
                        let rowParameter = rowSection.parameters[j]
                        let inputParameter = inputSection.parameters[j]
                        if (rowParameter.value !== inputParameter.value) {
                            value[inputParameter.jsonKey] = inputParameter.value
                        }
                    }
                }

                const param = {
                    serviceName: this.row.serviceName,
                    id: this.row.id,
                    value: value
                }
                this.$emit('modify', '/modifyserviceinformation', param,
                    (data) => {
                        if (data.status === constants.STATUS_ERROR_AUTH_FAILED) {
                            commonUtil.notifyMessage(self, 'Error', commonUtil.getMessageText(self.$i18n, "error_cannot_find_token"));
                        } else {
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyAiAppSetting").replace("{code}", data.status));
                        }
                    }
                )
            }

            this.expanded = false
            this.showDialog.edit = false
        },

        deleteAiAppSetting() {
            if (this.type === AiAppSettingUtility.TYPE_PROCESSOR) {
                this.$emit('delete', '/deleteprocessordefinition', {id : this.row.id})
            }  else if (this.type === AiAppSettingUtility.TYPE_SERVICE_INFORMATION) {
                this.$emit('delete', '/deleteserviceinformation', {serviceName: this.row.serviceName, id: this.row.id})
            }
            this.showDialog.delete = false
        },

        async assignRequest(input) {
            if (Object.keys(input.addTagList).length === 0 && Object.keys(input.removeTagList).length === 0) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_changing_information"));
                return;
            }

            if (this.type === AiAppSettingUtility.TYPE_PROCESSOR) {
                let operations = [];

                // addition list
                for (let key in input.addTagList) {
                    let tag = input.addTagList[key];
                    operations.push({
                        command: 'modifytalkgroup',
                        operation: {
                            id: tag.id,
                            newProcessorDefinitionIds: [this.row.id],
                        },
                    });
                }

                // removal list
                for (let key in input.removeTagList) {
                    let tag = input.removeTagList[key];
                    operations.push({
                        command: 'modifytalkgroup',
                        operation: {
                            id: tag.id,
                            removeProcessorDefinitionIds: [this.row.id],
                        },
                    });
                }

                await this.$emit('assign', '/multiop', {operations: operations})
            }  else if (this.type === AiAppSettingUtility.TYPE_SERVICE_INFORMATION) {
                switch (this.definition.serviceName) {
                    case AiAppSettingUtility.SERVICE_NAME_GIGARAKU_CAMERA:
                        const param = {
                            serviceName: this.row.serviceName,
                            id: this.row.id,
                            value: {
                                groupName: Object.values(input.editTagList).map(tag => tag.name)
                            }
                        }
                        await this.$emit('modify', '/modifyserviceinformation', param,
                            (data) => {
                                if (data.status === constants.STATUS_ERROR_NOT_ASSIGNED) {
                                    const notAssignedGroups = data.response.errorInformation.join(',')
                                    commonUtil.notifyMessage(this, 'Error', commonUtil.getMessageText(this.$i18n, "error_talkgroup_not_assigned").replace("{groupName}", notAssignedGroups));
                                } else {
                                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","assignRequest").replace("{code}", data.status));
                                }
                            }
                        )
                }
            }

            this.assignedGroup = null
            this.expanded = false
            this.showDialog.assign = false
        }
    }
}

</script>

<style scoped>

.record-item {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 28px;
    text-align: left;
    font-size: 12px;
}

.detailed-header {
    width: 100%;
    background-color: #f6f6f6;
    font-size: 12px;
}

.detailed-tr {
    border-bottom:1px #eee solid;
    overflow-wrap: anywhere;
}

.detailed-left {
    padding-left: 0;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 40%;
}

.title-box-left {
    padding: 10px 10px 10px 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}

button.transparent img {
    display: inline;
    vertical-align: middle;
    height: 18px;
}

.ai-record-detail {
    background-color:#ecf1fa;
    border-top: solid 1px #eee;
}

.ai-record-summary {
    background-color:transparent;
    border-top: solid 1px #eee;
}

</style>
